module.exports = __webpack_public_path__ + "static/img/Tino.fe2f0dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Tino.jpg
// module id = mBli
// module chunks = 0